import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AdminViewModel } from 'src/app/models/AdminViewModel';
import { PlanVM } from 'src/app/models/PlansVM';

@Injectable({
  providedIn: 'root'
})
export class PlanService {
  public baseurl = environment.apiUrl;
  private planApi = "api/Plan/";
  constructor(private http: HttpClient) { }

  getPlansSearchCategory() {
    const url = this.baseurl + this.planApi + 'GetAllPlansSearchCategory';
    return this, this.http.get(url).pipe();
  }

  MapUserToPlan(detailsData) {
    const url = this.baseurl + this.planApi + 'MapUserToPlan';
    return this, this.http.post(url,detailsData).pipe();
  }
  getAccessPermission(userId, roleId) {
    const url = this.baseurl + this.planApi + 'getAccessPermission' + '?UserId=' + userId + '&RoleId=' + roleId;;
    return this, this.http.get(url).pipe();
  }

  GetPlanList(data) {
    const url = this.baseurl + this.planApi + 'GetAllPlanList?'+ this.GetPlanListParameters(data);
    return this.http.get(url);
  }

  GetAllPlans() {
    const url = this.baseurl + this.planApi + 'GetAllPlans';
    return this.http.get(url);
  }

  UpdatePlan(data: PlanVM){
    const url = this.baseurl + this.planApi;
    return this.http.put(url, data)
  }

  GetPlanDetails(id) {
    const url = this.baseurl + this.planApi +  id;
    return this.http.get(url);
  }
  

  private GetPlanListParameters(data:AdminViewModel){
    let url="";
    if(data.pageNo){
      url=url+`pageNo=${data.pageNo}`
    }
    if(data.pageSize){
      url=url+`&pageSize=${data.pageSize}`
    }
    if(data.searchText){
      url=url+`&searchText=${data.searchText}`
    }
    if(data.sort){
      url=url+`&sort=${data.sort}`
    }
    if(data.columnName){
      url=url+`&columnName=${data.columnName}`
    }
    if(data.regionId){
      url=url+`&regionId=${data.regionId}`
    }
    if(data.countryId){
      url=url+`&countryId=${data.countryId}`
    }
    if(data.shippinglineId){
      url=url+`&shippinglineId=${data.shippinglineId}`
    }
   return url;
}
}
